import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { safeBtoa } from '../utils/base64';

export function base64EncodingInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  if (!req.url.startsWith(environment.colab.apiBaseUrl)) {
    // only intercept Colab API requests
    // It also intercepts requests to the auth server (tnrIdentity)
    return next(req);
  }

  if (req.method !== 'POST' || !req.body) {
    return next(req);
  }

  // base64 encode for the request body for avoiding issues with AFD rules
  req = req.clone({
    body: safeBtoa(JSON.stringify(req.body))
  });
  return next(req);
}
